import axios from 'axios'
import store from '../store/store.js'
import router from '../router.js'
import NProgress from 'nprogress'

const client = axios.create({
  baseURL: '/api/',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

client.interceptors.request.use(config => {
  config.headers.Authorization = `Bearer ${store.state.user.token}`

  return config
})

client.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response && error.response.status == 401) {
    if (error.config.baseURL == '/api') error.config.baseURL = ''

    return client.post('Account/Refresh', { jwtToken: store.state.user.token, refreshToken: store.state.user.refreshToken }).then(res => {
      //store the new token,then make the request again
      return store.dispatch('user/setTokens', { token: res.data.jwtToken, refreshToken: res.data.refreshToken }).then(() => {
        return client.request(error.config).then(r => {
          return Promise.resolve(r)
        })
      })
    }, e => {
      store.dispatch('user/logout').then(() => {
        router.push({
          name: 'account/login'
        })
        return Promise.reject(e)
      })
    })
  } else {
    return Promise.reject(error)
  }
})

export default {
  get(path, dontShowNProgress) {
    if (!dontShowNProgress) NProgress.start()
    return client.get(path).then(res => { 
      if (!dontShowNProgress) NProgress.done() 
      return Promise.resolve(res)
    }).catch(e => {
      if (!dontShowNProgress) NProgress.done()
      return Promise.reject(e)
    })
  },
  post(path, body) {
    NProgress.start()
    return client.post(path, body).then(res => {
      NProgress.done()
      return Promise.resolve(res)
    }).catch(e => {
      NProgress.done()
      return Promise.reject(e)
    })
  },
  put(path, body) {
    NProgress.start()
    return client.put(path, body).then(res => {
      NProgress.done()
      return Promise.resolve(res)
    }).catch(e => {
      NProgress.done()
      return Promise.reject(e)
    })
  },
  delete(path) {
    NProgress.start()
    return client.delete(path).then(res => {
      NProgress.done()
      return Promise.resolve(res)
    }).catch(e => {
      NProgress.done()
      return Promise.reject(e)
    })
  },
  postFormData(path, body) {
    NProgress.start()
    return client.post(path, body, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
      NProgress.done()
      return Promise.resolve(res)
    }).catch(e => {
      NProgress.done()
      return Promise.reject(e)
    })
  },
  getFileDownload(path) {
    NProgress.start()
    return client.get(path, { responseType: 'blob' }).then(res => {
      NProgress.done()
      return Promise.resolve(res)
    }).catch(e => {
      NProgress.done()
      return Promise.reject(e)
    })
  }
}
